/**
 * 비로그인 방문자의 영구 게스트 id — localStorage `catchmoments_guest_id`. 채널톡 memberId · Clarity custom-id 가 같은 값을 쓴다.
 */

const STORAGE_KEY = 'catchmoments_guest_id';

/**
 * 저장된 게스트 id 를 읽고, 없으면 `<timestamp>-<rand>-<rand>` 로 만들어 저장한다.
 * @returns {string} 게스트 id
 * @throws localStorage 접근이 막힌 브라우저에서는 그 예외를 그대로 던진다
 */
export function getOrCreateGuestId(): string {
  let guestId = localStorage.getItem(STORAGE_KEY);

  if (!guestId) {
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2, 15);
    const randomStr2 = Math.random().toString(36).substring(2, 15);
    guestId = `${timestamp}-${randomStr}-${randomStr2}`;
    localStorage.setItem(STORAGE_KEY, guestId);
  }

  return guestId;
}
